import React, { useEffect } from 'react'
//import all routines here/activities

function Routines() {
    useEffect(() => {

    })
    return (
        <div>Routines</div>
    )
}

export default Routines